import React, { Component } from "react";
import ReactLoading from "react-loading";
import PropTypes from "prop-types";
import I18N from "../../I18N";
import { ReactComponent as ReTest } from "../../assets/icons/refresh2.svg";
import "./testBox.scss";

const TestFailed = () => {
  return (
    <div className="test-failed">
        <p>{I18N.t("TEST_FAILED")}</p>
    </div>
  );
};

class TestBox extends Component {

  handleReTest = () => {
    const { handleReTest } = this.props;
    handleReTest();
  };

  render() {
    const { testName, children, buttonRef, error , isLoading} = this.props;
    return (
      <div className="test-box">
        <p className="test-box__title">{testName}</p>
        {isLoading ? (
          <div className="test-box__loader-wrapper">
            <ReactLoading
              type={"bars"}
              color={"#16c4ab"}
              height={30}
              width={60}
            />
          </div>
        ) : error ? (
          <TestFailed />
        ) : (
          children
        )}
        <button
          ref={buttonRef}
          className="test-box__retest-button"
          onClick={this.handleReTest}
        >
          <ReTest className="test-box__retest-button" />
        </button>
      </div>
    );
  }
}

TestBox.propTypes = {
  testName: PropTypes.string.isRequired,
  handleReTest: PropTypes.func.isRequired
};
TestBox.defaultProps = {};

export default TestBox;
